export const WORKSPACE_IMAGE_QUERY_KEY = ["workspace-image"] as const;

export const getWorkspaceImageQueryKey = (workspaceId: string) => [...WORKSPACE_IMAGE_QUERY_KEY, workspaceId] as const;
